import apiClient from "./axios"

const BASE_URL = "/vehicle-stock"
const STOCK_BASE_URL = "/vehicle-stocks"

export const getVehicleImageIds = async vehicleId => {
  const response = await apiClient.get(`${BASE_URL}/${vehicleId}/image-ids`)
  return response.data
}

export const getVehicleImageFile = async (vehicleId, imageId, imgType) => {
  const response = await apiClient.get(
    `${BASE_URL}/${vehicleId}/image/${imageId}`,
    {
      params: { imgType },
      responseType: "blob",
      skipToast: true,
    }
  )

  return new File(
    [response.data],
    `${vehicleId}-image-${imageId}.jpg`,
    {
      type: response.data.type,
    }
  )
}

export const importVehicleDriveImages = async ({
  vehicleId,
  driveLink,
  limit,
  offset,
  chunkSize,
  replaceExisting,
  maxKb,
  signal,
}) => {
  const response = await apiClient.post(
    `${STOCK_BASE_URL}/${vehicleId}/import-drive-images`,
    {
      drive_link: driveLink,
      ...(limit !== undefined ? { limit } : {}),
      ...(offset !== undefined ? { offset } : {}),
      ...(chunkSize !== undefined ? { chunk_size: chunkSize } : {}),
      ...(replaceExisting !== undefined
        ? { replace_existing: replaceExisting }
        : {}),
      ...(maxKb !== undefined ? { max_kb: maxKb } : {}),
    },
    {
      signal,
    }
  )

  return response.data
}
